<div mat-dialog-title>
  {{'Applied Filters'| translate}}
  <span class="float-right pointer" (click)="close()">
    <i class="fa fa-times close-btn "></i>
  </span>
  <!-- <span style="float: right;" (click)="close()" ><mat-icon>close</mat-icon>  </span> -->


</div>
<div mat-dialog-content class="">
  <div class="search-bar" *ngIf="data  && data.length">
    <div class="search item" *ngFor="let item of data"> {{item}}
      <!-- <i class="fa fa-close mx-1"></i> -->
    </div>
  </div>

</div>
<mat-dialog-actions>
  <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

  <button style="min-width: 100px;" class="ml-auto  blob-btn-cancel btn-sm btn mx-1 mx-1 tallite-action"
    (click)="close()">
    {{ 'Clear all' | translate}}
    <span class="blob-btn-cancel__inner">
      <span class="blob-btn-cancel__blobs">
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
      </span>
    </span>
  </button>
  <button style="min-width: 100px;" class="blob-btn  btn  btn-sm  mx-1 tallite-action" type="submit" (click)="save()">
    {{ 'BTN.ok' | translate }}
    <span class="blob-btn__inner">
      <span class="blob-btn__blobs">
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
      </span>
    </span>
  </button>
</mat-dialog-actions>
